import { formatStoredPath } from "../domain/paths";
import { openLocalDatabase, type RecoveryRecord } from "../persistence/local_database";

/** Keeps crash recovery browser-local and subordinate to the disk document. */
export class RecoveryStore {
  /** Stores a complete candidate document before its canonical save. */
  public async put(
    boardPath: readonly string[],
    documentJson: string,
    savedAt: Date,
  ): Promise<void> {
    const database = await openLocalDatabase();
    await database.put("recovery", {
      boardPath: formatStoredPath(boardPath),
      documentJson,
      savedAt: savedAt.toISOString(),
    });
  }

  /** Reads recovery state without changing the canonical workspace. */
  public async get(boardPath: readonly string[]): Promise<RecoveryRecord | null> {
    const database = await openLocalDatabase();
    return (await database.get("recovery", formatStoredPath(boardPath))) ?? null;
  }

  /** Clears only the recovery copy matching a completed canonical save. */
  public async clear(boardPath: readonly string[]): Promise<void> {
    const database = await openLocalDatabase();
    await database.delete("recovery", formatStoredPath(boardPath));
  }
}
